export const LINK_INSTAGRAM = 'https://www.instagram.com/olimpcom_official/'
